import { MessageText } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const MessageIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <MessageText width={size} height={size} color={color} {...rest} />;

MessageIcon.displayName = 'MessageIcon';

export default MessageIcon;
